import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/pigments',
    name: 'PUT_PIGMENTS',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
